export default __webpack_public_path__ + "static/fa-light-300-85dee30836f1fab070c9a9014ac7e9da.svg";